module.exports = __webpack_public_path__ + "static/media/trailblazers.093a1017.jpg";